import './App.css';
import React from 'react';
import PPVisualizer from './PPVisualizer/PPVisualizer';


function App() {

  return (
    <div className="App">
      <PPVisualizer></PPVisualizer>
    </div>
  );
}

export default App;
